<div id="overlay">
  <!--  <div id="dummy-overlay" (click)="onCloseClick($event)"></div> -->
  <div style="position: absolute; width: 100%; height: 100%">
    <!-- <div id="dummy-overlay" (click)="onCloseClick($event)"></div> -->
    <table class="wrapper">
      <tr>
        <td>
          <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
          <div class="popup-img">
            <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
            <div>
              <img
                class="img-bg"
                src="assets/images/common/popup_bg_medium.webp?t={{ version }}"
              />
              <img
                class="close-icon-img"
                [appImageSprite]="'close'"
                [params]="menu_icons"
                (click)="onCloseClick($event)"
              />
              <h3
                class="popup-header lang-specific-font-name"
                [ngClass]="
                  'popup-header-' +
                  data.isfromFavorite +
                  '-' +
                  data.currentLanguage
                "
              >
                {{
                  (data.isfromFavorite == 'fromFavorite'
                    ? ('LANG00825' | translate) + ' - '
                    : '') + ('LANG00141' | translate)
                }}
              </h3>
              <h3 class="popup-cntnt lang-specific-font-name">
                {{ 'LANG00142' | translate }}
              </h3>
              <div
                class="list-item-container"
                *ngFor="let limit of betLimits; let i = index"
                [ngClass]="[
                  'list-' + i,
                  userCurrency + '-list-item-container',
                  userCurrency + '-text-content-string'
                ]"
              >
                <span class="list-item-center">
                  <img
                    *ngIf="!selectedBets[i]"
                    class="radio"
                    [appImageSprite]="'option_unselect'"
                    [params]="menu_icons"
                  />
                  <img
                    *ngIf="selectedBets[i]"
                    class="radio"
                    [appImageSprite]="'option_select'"
                    [params]="menu_icons"
                  />
                  <img
                    class="bet-icon"
                    [appImageSprite]="'bet_icon'"
                    [params]="common_icons"
                  />
                  <h3
                    class="betLimits"
                    [ngClass]="[userCurrency + '-betLimits']"
                    (mouseover)="buttonOverOrOut(i)"
                    (mouseout)="buttonOverOrOut(i)"
                    (click)="buttonClick(i)"
                  >
                    {{ limit.min | usercurrency | currencysymbol }}-{{
                      limit.max | usercurrency | currencysymbol
                    }}
                  </h3>
                </span>

                <span
                  class="bet-limit-hover"
                  (mouseover)="buttonOverOrOut(i)"
                  (mouseout)="buttonOverOrOut(i)"
                  (click)="buttonClick(i)"
                ></span>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
